import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import BreakOnNewline from 'lib/tags/break-on-newline'

const ReadMore = ({ id, onToggle, isExpanded, text, numberOfLines = 3, noButton, external }) => {
  const handleOnClick = () => {
    if (external) {
      window.location.href = external
    } else {
      onToggle(id)
    }
  }

  return (
    <div className='read-more-section-container'>
      <div
        className={`read-more-text${!isExpanded ? ' read-more-text--truncated' : ''}`}
        style={{
          display: !isExpanded ? '-webkit-box' : 'block',
          WebkitLineClamp: !isExpanded ? numberOfLines : 'unset',
          WebkitBoxOrient: !isExpanded ? 'vertical' : 'unset'
        }}
      >
        <BreakOnNewline text={text} />
      </div>

      {!noButton && (
        <div className='read-more-button-container'>
          <div onClick={handleOnClick} className='read-more-button'>
            {isExpanded ? I18n.t('courses.show.read_less') : I18n.t('courses.show.read_more')}
          </div>
        </div>
      )}
    </div>
  )
}

ReadMore.propTypes = {
  id: PropTypes.string,
  onToggle: PropTypes.func,
  isExpanded: PropTypes.bool,
  text: PropTypes.string,
  numberOfLines: PropTypes.number,
  noButton: PropTypes.bool,
  external: PropTypes.string
}

export default ReadMore
